var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? [
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-sm",
                      on: { click: _vm.getInvoices },
                    },
                    [_vm._v("Обновить заявки")]
                  ),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "table table-sm table-hover" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.drugs, function (drugData, drugId, i) {
                      return _vm.orders[drugId]
                        ? _c("tr", [
                            _c("td", [_vm._v(_vm._s(drugId))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(drugData.title))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c("p", [
                                  _vm._v("Наличие: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.inStores[drugId] ?? 0)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.incomeDrugs[drugId]?.invoices ?? [],
                                  function (inv) {
                                    return _c("p", [
                                      _c("strong", [
                                        _vm._v(_vm._s(+inv.qty) + " уп."),
                                      ]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.printDate(
                                              _vm.invoices[inv.invoice_id]
                                                .delivery_date,
                                              "DD.MM.YYYY"
                                            )
                                          )
                                      ),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c("p", [
                                _vm._v("свбд: "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      (_vm.inStores[drugId] ?? 0) +
                                        (_vm.supplyDrugs[drugId] ?? 0) -
                                        (_vm.reserved[drugId] ?? 0)
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("рзрв: "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.reserved[drugId] ?? 0)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm._l(_vm.orders[drugId] ?? [], function (o) {
                                  return [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-xs btn-outline-info mb-1 mr-1",
                                        on: {
                                          click: function ($event) {
                                            return _vm.orderToEdit(o.id)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-eye",
                                        }),
                                        _vm._v(" " + _vm._s(o.id) + " "),
                                        o.is_reserved
                                          ? _c("strong", [_vm._v("резерв")])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ])
                        : _vm._e()
                    }),
                    0
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Поступление")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "95px" } }, [_vm._v("Бронь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявки")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }